import { useTranslations } from 'next-intl';
import { I } from './icons';

type SlashPopoverProps = {
  active?: number;
};

// 항목 수는 이 아이콘 배열이 정한다(번역 배열과 짝이 밀리지 않게).
const ITEM_ICONS = [I.tts, I.sparkle, I.globe, I.music, I.hand];

export function SlashPopover({ active = 0 }: SlashPopoverProps) {
  const t = useTranslations('home.discord');
  return (
    <div className="slash-pop">
      <div className="head">
        <span>{t.rich('slashHead', { b: (chunks) => <b>{chunks}</b> })}</span>
        <span>↑↓ · enter</span>
      </div>
      <ul>
        {ITEM_ICONS.map((Ic, i) => (
          <li key={i} className={i === active ? 'active' : ''}>
            <span className="ic"><Ic /></span>
            <span>
              <span className="name">{t(`slashItems.${i}.name`)}</span>
              <span className="desc">{t(`slashItems.${i}.desc`)}</span>
            </span>
            <span className="key">tab</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
